import { ReactComponent } from './number-3-xs.svg';
export const Number3IconXs = ReactComponent;
export default ReactComponent;

//# sourceMappingURL=number-3-xs.js.map